/* eslint-disable @typescript-eslint/no-explicit-any */

export enum SelectSize {
  sm = '32px',
  md = '40px',
  lg = '48px',
}

export enum SelectFontSize {
  sm = '0.875rem',
  md = '1rem',
  lg = '1.125rem',
}

export const customStyles = (
  size: keyof typeof SelectSize,
  bg: string,
): any => ({
  control: (base: any) => ({
    ...base,
    background: bg,
    fontSize: SelectFontSize[size],
    minHeight: SelectSize[size],
  }),
  menu: (base: any) => ({
    ...base,
    fontSize: SelectFontSize[size],
  }),
  valueContainer: (base: any) => ({
    ...base,
    position: size === 'sm' ? 'static' : 'relative',
  }),
});
